import { render, staticRenderFns } from "./largeMoney.vue?vue&type=template&id=454eb53e&scoped=true&"
import script from "./largeMoney.vue?vue&type=script&lang=js&"
export * from "./largeMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454eb53e",
  null
  
)

export default component.exports